// import 'es6-shim';  // hopefully not necessary with babel
import 'jquery';
// import 'lightcase';
import 'lity';
import jcf from '../lib/jcf';
import Flickity from 'flickity';

export default {
  init(components) {
    Flickity.defaults.dragThreshold = 20

    // JavaScript to be fired on all pages
    // legacy code?
    // $('[data-toggle="more"]').on('click', (e) => {
    //   const target = document.querySelector(e.currentTarget.getAttribute('data-target'));

    //   if (target) {
    //     $(e.currentTarget).slideUp(400, () => $(e.currentTarget).remove()).fadeOut(200);
    //     $(target).slideDown();
    //   }
    // });

    // Disable transition during a resize
    $(window).on('resize', window.requestAnimationFrame.bind(window, () => {
      $('body').addClass('no-transition');

      setTimeout(window.requestAnimationFrame.bind(window, () => {
        $('body').removeClass('no-transition');
      }, 50));
    }));

    jcf.replaceAll();

    // $('[data-lightbox]').lity({
    //   onFinish: {
    //     corge: function corge() {
    //       $("#lightcase-content iframe").each(function (n) {
    //         $(this).attr("id", "player" + n);
    //         $(this).after("<script src='/static/dtm-youtube-api.js'></script>");
		//   });
		//   /*Removed for Events sites
    //       _satellite.setVar('popUpVideoName', $(this).attr("title"));
    //       _satellite.track('popupVideoOpened');*/
    //     }
    //   },
    //   onClose : {
    //     grault: function grault() {
		//   // location.reload();
		//   /*Removed for Events sites
    //       _satellite.setVar('popUpVideoName', $(this).attr("title"));
    //       _satellite.track('popupVideoClosed');*/
    //     }
    //   }
    // });

    $('a, button, [type="button"]').on('click', (e) => {
      // If this is a mouse click (rather than an enter click), don't apply focus styling
      if (typeof e.originalEvent !== 'undefined' && e.originalEvent.detail > 0) {
        $(e.currentTarget).blur();
      }
    });
  },

  finalize() {
    $('body').addClass('stage-1-loaded stage-2-loaded');
  }
};
